export const formatAttendeeName = (name?: string | null) => {
  return name?.trim() ?? "";
};
